module.exports = __webpack_public_path__ + "assets/images/premium-features/tc-payroll-f41492.png";